<script>
  import Person from "./Person.svelte";

  export let item;
  export let persons = [];

  let eventDescription3WantSplitShow = false;
  let showPart2 = false;

  let eventDescription3Parts = [];

  if (item.eventDescription3.includes("#####")) {
    eventDescription3WantSplitShow = true;
    eventDescription3Parts = item.eventDescription3.split("#####");
  }
</script>

{#if persons.length == 1}
  <div class="flex flex-wrap gap-3">
    {#each persons as person}
      <Person {...person} />
    {/each}
    <div class="min-w-full flex-1 xs:min-w-[250px]">
      {#if item.eventDescription3}
        <p class="mb-2 whitespace-pre-line text-sm">
          {#if eventDescription3WantSplitShow}
            {eventDescription3Parts[0]}
            {#if !showPart2}
              <br />
              <button
                type="button"
                class="btn btn--link btn--inline not-prose float-right mb-2"
                on:click={() => {
                  showPart2 = true;
                }}>Mehr erfahren <img src="/_Resources/Static/Packages/Fpi.ThemeBase/Assets/SmallChevronsIconC.png" alt="" class="h-5 w-5" /></button
              >
            {/if}
            {#if showPart2}
              {eventDescription3Parts[1]}
            {/if}
          {:else}
            {item.eventDescription3}
          {/if}
        </p>
      {/if}
    </div>
  </div>
{:else}
  <div class="clearfix flex flex-wrap gap-3 sm:clear-both sm:block">
    {#each persons as person, index}
      {#if index == 0}
        <Person {...person} class="sm:float-left sm:mr-3" />
      {:else if index == 1}
        <Person {...person} class="sm:float-right sm:ml-3" />
      {/if}
    {/each}
    {#if item.eventDescription3}
      <p class="mb-2 text-sm">{item.eventDescription3}</p>
    {/if}
  </div>
{/if}
